// src/context/AuthContext.js
import React, { createContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';


export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token && !isLoggingIn) {
      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decodedToken.exp < currentTime) {
          localStorage.removeItem('token');
          setUser(null);
        } else {
          setUser(decodedToken);
        }
      } catch (error) {
        setUser(null);
      }
    }
  }, [isLoggingIn]);

  const login = (token) => {
    localStorage.setItem('token', token);
    const decodedToken = jwtDecode(token);
    setUser(decodedToken);
    setIsLoggingIn(false);
  };

  const startLoginProcess = () => setIsLoggingIn(true);
  const endLoginProcess = () => setIsLoggingIn(false);

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  // Add this function
  const refreshUserRole = () => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      setUser(decodedToken);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, isLoggingIn, startLoginProcess, endLoginProcess, refreshUserRole }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;